"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _notification = _interopRequireDefault(require("./notification"));

var _types = require("./types");

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var _state$notification = state.notification,
      type = _state$notification.type,
      duration = _state$notification.duration,
      open = _state$notification.open,
      title = _state$notification.title,
      outside = _state$notification.outside;
  return {
    type: type,
    duration: duration,
    open: open,
    title: title,
    outside: outside
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeNotification: function closeNotification() {
      return dispatch({
        type: _types.CLOSE_NOTIFICATION,
        payload: {}
      });
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_notification.default);

exports.default = _default;